import { TopBar } from '../../top-bar/TopBar';
import { Footer } from '../../footer/Footer';
import { PublicOptions } from '../../../data/publicOptions';
import { About } from '../about/About';
import { Banner } from './Banner';
import { Topics } from './Topics';
import './Home.css';
import { memo, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Sponsors } from './Sponsors';
import { SpeakersList } from '../../../data/speakersList';
import { KeynoteList } from '../../../data/KeynotesList';
// import Alberto from '../../../assets/images/speakers/AlbertoGuijosaC.jpg';
import { SpeakerModal } from '../speakers/SpeakersWrapper';
import SpecialIssueBanner from '../../../assets/HOME_Revista_SNN2026.png';
import { Link } from 'react-router-dom';
import { Fees } from '../fees/Fees';
import Logo from './logo.png';
import AbstractImg from "../user-home/abstract.png";

const HomeWrapper = memo(() => {
  const { hash } = useLocation();
  const navigate = useNavigate();
  const [selectedSpeaker, setSelectedSpeaker] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);

  // const specialGuestList = [
  //   {
  //     id: 0,
  //     name: 'Prof. Alberto Güijosa',
  //     affiliation: 'ICN-UNAM, Mexico',
  //     img: Alberto,
  //     topic_id: null,
  //     resume:
  //       'Alberto Güijosa is a Professor at the Institute of Nuclear Sciences of the National Autonomous University of Mexico, where he is additionally the Director of the Graduate Program in Physical Sciences. He got his Ph.D. in 1999 at Princeton University, specializing in string theory. For his work in the holographic (or AdS/CFT) correspondence, he was awarded the 2010 Research Prize of the Mexican Academy of Sciences.',
  //     title: "Some Essentially New Physical Ideas: Feynman's Legacy",
  //     abstract:
  //       '<p>Richard P. Feynman is widely recognized as one of the most original and influential theoretical physicists of the twentieth century. This talk will provide a brief overview of some of his contributions, with emphasis on his Nobel-Prize-winning work, at a level accessible to non-specialists.</p>',
  //   },
  // ];

  const closeModal = () => {
    setIsModalOpen(false);
  };

  // eslint-disable-next-line no-unused-vars
  const selectSpeaker = (speakerId, list) => {
    console.log(speakerId, list);
    const speaker = list.find((speaker) => speaker.id === speakerId);
    setSelectedSpeaker(speaker);
    setIsModalOpen(true);
  };

  const access_token = localStorage.getItem('access_token');

  useEffect(() => {
    if (hash) {
      console.log('Getting token');
      console.log(hash.substring(1));
      const pairs = hash.substring(1).split('&');
      const result = {};

      pairs.forEach((pair) => {
        const [key, value] = pair.split('=');
        result[key] = decodeURIComponent(value);
      });

      localStorage.setItem('id_token', result['id_token']);
      localStorage.setItem('access_token', result['access_token']);
      localStorage.setItem('expires_in', result['expires_in']);
      localStorage.setItem('token_type', result['token_type']);

      navigate('/home');
    }
  }, []);

  useEffect(() => {
    if (access_token) {
      navigate('/home');
    }
  }, []);


  return (
    <>
      <TopBar options={PublicOptions} />
      <div className={isModalOpen ? '' : 'hide'}>
        <SpeakerModal speaker={selectedSpeaker} closeModal={closeModal} />
      </div>
      <div className="content">
        <Banner/>
          <div className="snn-user-home-main-content-submit-wrapper">
              <div className="snn-user-home-main-content-submit-ribbon">
                  <div className="snn-user-home-main-content-submit-ribbon-content">
                      <p className="snn-user-home-main-content-small-text gold-text">
                          Abstract submission close Jan, 13 - Feb, 22
                      </p>
                      {/*<p className="snn-user-home-main-content-large-semi">Under review</p>*/}
                      <Link to="/abstracts/submit">
                          <div className="snn-user-home-main-content-submit-ribbon-button">
                              Submit now <span className="material-symbols-outlined">arrow_right_alt</span>
                          </div>
                      </Link>
                  </div>
                  <div className="snn-ribbon-img-wrapper">
                      <img src={AbstractImg} alt="abstract"/>
                  </div>
              </div>
          </div>
        <Fees />
        <section className="snn-page-section snn-topics">
          <h2 className="snn-title">Important dates</h2>
          <p className="snn-justify">
            <ul>
              <li>Abstract submission open: <strong>January 13, 2026</strong></li>
              <li>Abstract submission close: <strong>February 22, 2026</strong></li>
              <li>Acceptance of contributions: <strong>April 1, 2026</strong></li>
              <li>Pre- registration: <strong>April 6 to 30, 2026</strong></li>
            </ul>
          </p>
        </section>
        <Topics/>
        <div className="snn-page-section ">
          <section className="plenary-grid">
            <h2 className="snn-title">Plenary Speakers</h2>
            <div className="snn-user-home-speakers-wrapper">
              {SpeakersList.map((speaker) => (
                  <div
                      className="snn-user-home-main-speaker-wrapper"
                      key={speaker.name}
                      onClick={() => selectSpeaker(speaker.id, SpeakersList)}
                  >
                    <img
                        className="snn-user-home-main-speaker-wrapper-speaker"
                        src={speaker.img}
                        alt={speaker.name}
                    />

                    <img
                        className="snn-user-home-main-speaker-wrapper-topic"
                        src={Logo}
                    />
                      <div className="snn-user-home-main-speaker-wrapper-info">
                          <p>{speaker.name} <br/>
                              {speaker.university}</p>
                      </div>
                  </div>
              ))}
            </div>
          </section>
          <section className="plenary-grid">
            <h2 className="snn-title">Keynotes</h2>
            <div className="snn-user-home-keynotes-wrapper">
              {KeynoteList.map((speaker) => (
                  <div
                      className="snn-user-home-main-speaker-wrapper"
                      key={speaker.name}
                      onClick={() => selectSpeaker(speaker.id, KeynoteList)}
                  >
                    <img
                        className="snn-user-home-main-speaker-wrapper-speaker"
                        src={speaker.img}
                        alt={speaker.name}
                    />

                    <img
                        className="snn-user-home-main-speaker-wrapper-topic"
                        src={Logo}
                    />
                      <div className="snn-user-home-main-speaker-wrapper-info">
                          <p>{speaker.name} <br/>
                              {speaker.university}</p>
                      </div>
                  </div>
              ))}
            </div>
          </section>
        </div>
        <Sponsors/>
        <div className="special-issue-banner-wrapper snn-page-section">
          <h2></h2>
          <Link to="/special-issue">
            <img src={SpecialIssueBanner}/>
          </Link>
        </div>
        <About/>
        <section className="snn-page-section">
          <h2 className="snn-title">Social media</h2>
          <div className="snn-social-wrapper">
            <iframe
                src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fsimposiocnyn&tabs=timeline&width=500&height=500&small_header=true&adapt_container_width=true&hide_cover=false&show_facepile=true&locale=es_LA"
                width="500"
                height="500"
                style={{ border: 'none', overflow: 'hidden', maxWidth: '100%' }}
                scrolling="no"
                frameBorder="0"
                allowFullScreen={true}
                allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                title="Facebook Simposio de Nanociencias y Nanomateriales"
            ></iframe>
          </div>
        </section>
      </div>
      <Footer/>
    </>
);
});
HomeWrapper.displayName = 'HomeWrapper';
export default HomeWrapper;
